import { TextInput } from '@delmonicos/shared-design-system-react/src/components/input/text-input';
import { PowerType } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/enums/ocpi-protocol-enums';
import { useTranslation } from 'react-i18next';

interface PhysicalSocketDcPowerTypeProps {
  value?: PowerType | '';
}

// Read-only stand-in for the power type dropdown. It shows what the form actually holds (set to
// DC when the standard is picked) instead of assuming DC, so a missing value is never hidden.
export const PhysicalSocketDcPowerType = ({
  value,
}: PhysicalSocketDcPowerTypeProps): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <TextInput
      readOnly
      required
      label={t('delmonicos-shared-sdk.outputs-physical-socket.power-type')}
      value={
        value
          ? t(`delmonicos-shared-sdk.ocpi-protocol-enums.power-type.${value}`)
          : ''
      }
    />
  );
};
